'use strict';

function CompanyTaskCategoryService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/reminders/categories', {}, {
    "update": {
      method: "PUT"
    }
  });
}

angular.module('dokiv')
  .factory('CompanyTaskCategoryService', [
    '$resource',
    'config',
    CompanyTaskCategoryService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/tasks/CompanyTaskCategoryService.js
// module id = 418
// module chunks = 0